import { HomeVideoTable } from './HomeVideoTable';
export default HomeVideoTable;
